import type { FilterConfigResolvableField } from './resolve-filter-config';
import { useFieldTypeTemplates } from '#layers/data-model/public';
import { resolveFilterConfig } from './resolve-filter-config';

/**
 * Binds resolveFilterConfig to the current fieldTypeTemplates reactive scope so callers
 * don't have to thread the map through every call site.
 */
export function useFilterConfigResolver() {
	const fieldTypeTemplates = useFieldTypeTemplates();

	return {
		resolveFilterConfig: (field: FilterConfigResolvableField | undefined) =>
			resolveFilterConfig(field, fieldTypeTemplates.value),
		supportedOperatorsFor: (field: FilterConfigResolvableField) =>
			resolveFilterConfig(field, fieldTypeTemplates.value)?.supportedOperators,
		defaultOperatorFor: (field: FilterConfigResolvableField) =>
			resolveFilterConfig(field, fieldTypeTemplates.value)?.defaultOperator,
	};
}
